import React from "react";
import { Redirect } from "react-router-dom";
// User profile

import PublicEvents from "pages/Events/PublicEvents";

const publicRoutes = [
  { path: "/public/events/:clubId", component: PublicEvents },
  { path: "*", component: () => <Redirect to="/public/events/1" /> },
];

export { publicRoutes };
